export default __webpack_public_path__ + "static/media/registration.198c5061.svg";